const VoucherStatusEnums = [
  'Work in Progress',
  'Draft',
  'Submitted',
  'Approved',
  'Closed',
  'Void',
  'Deleted',
];

const VoucherStatusEnumsShort = ['WP', 'DR', 'SB', 'AP', 'CL', 'VD', 'DL'];

const VoucherStatusTypeEnums = [
  { val: 0, Name: 'Work in Progress' },
  { val: 1, Name: 'Draft' },
  { val: 2, Name: 'Submitted' },
  { val: 3, Name: 'Approved' },
  { val: 4, Name: 'Closed' },
  { val: 5, Name: 'Void' },
  { val: 6, Name: 'Deleted' },
];

const DealStatusEnums = [
  'Draft',
  'Submitted',
  'Approved',
  'Closed',
  'Void',
  'Deleted',
];
const DealStatusEnumsObj = [
  { label: 'Draft', value: '0' },
  { label: 'Submitted', value: '1' },
  { label: 'Approved', value: '2' },
  { label: 'Closed', value: '3' },
  { label: 'Void', value: '4' },
  { label: 'Deleted', value: '5' },
];

const VoucherTypeIdEnums = {
  1: 'Receivable',
  2: 'Payable',
  3: 'Receivable Credit',
  4: 'Payable Credit',
  5: 'Direct Payment Received',
  6: 'Direct Payment Sent',
};

const VoucherTypeIdEnumsShort = {
  1: 'REC',
  2: 'PAY',
  3: 'RCR',
  4: 'PCR',
  5: 'RDP',
  6: 'PDP',
};

const VoucherTypeList = [
  {
    VoucherTypeId: 1,
    Description: 'Receivable',
  },
  {
    VoucherTypeId: 2,
    Description: 'Payable',
  },
  {
    VoucherTypeId: 3,
    Description: 'Receivable Credit',
  },
  {
    VoucherTypeId: 4,
    Description: 'Payable Credit',
  },
  {
    VoucherTypeId: 5,
    Description: 'Direct Payment Received',
  },
  {
    VoucherTypeId: 6,
    Description: 'Direct Payment Sent',
  },
];

module.exports = {
  VoucherStatusEnums,
  VoucherStatusTypeEnums,
  DealStatusEnums,
  DealStatusEnumsObj,
  VoucherTypeIdEnums,
  VoucherTypeIdEnumsShort,
  VoucherTypeList,
  VoucherStatusEnumsShort,
};
